import { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function TeacherWelcomeScreen() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const leavingRef = useRef(false);

  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);

  const doNavigate = useCallback(() => {
    if (leavingRef.current) return;
    leavingRef.current = true;
    setLeaving(true);
    setTimeout(() => navigate("/teacher", { replace: true }), 500);
  }, [navigate]);

  useEffect(() => {
    if (!state) {
      navigate("/teacher", { replace: true });
      return;
    }
    const t1 = setTimeout(() => setVisible(true), 40);
    const t2 = setTimeout(doNavigate, 5000);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const firstName = (state?.name || "").split(" ")[0] || "there";

  return (
    <div
      data-testid="teacher-welcome-screen"
      style={{
        background: "linear-gradient(to bottom, #1c2b3a 0%, #2e3f52 50%, #3d5166 100%)",
        opacity: leaving ? 0 : visible ? 1 : 0,
        transition: "opacity 0.5s ease",
      }}
      className="min-h-screen flex items-center justify-center px-4 py-10"
    >
      {/* Card */}
      <div
        style={{
          opacity: visible && !leaving ? 1 : 0,
          transform: visible && !leaving ? "translateY(0px)" : "translateY(16px)",
          transition: "opacity 0.7s ease 0.08s, transform 0.7s ease 0.08s",
          maxWidth: 460,
          width: "100%",
        }}
        className="relative bg-white rounded-3xl shadow-xl px-10 py-12 text-center"
      >
        {/* Brand logo */}
        <img src="/mitraa-logo-transparent.webp" alt="Mitraa" className="w-16 h-16 object-contain mx-auto mb-6" />

        <h1
          data-testid="teacher-welcome-screen-headline"
          className="font-display text-3xl sm:text-4xl font-bold text-slate-800 leading-tight mb-5"
        >
          Welcome, {firstName}! 👋
        </h1>

        <p
          data-testid="teacher-welcome-screen-message"
          className="text-base text-slate-600 leading-relaxed mb-9"
        >
          Mitraa is at your service.
        </p>

        {/* CTA button — appears immediately */}
        {visible && (
          <button
            data-testid="teacher-welcome-screen-lets-go"
            onClick={doNavigate}
            className="fade-up inline-flex items-center gap-2 px-8 py-3 rounded-full font-semibold text-sm text-white"
            style={{
              background: "linear-gradient(135deg, #475569 0%, #334155 100%)",
              boxShadow: "0 4px 18px rgba(71,85,105,0.25)",
              transition: "transform 0.18s ease, box-shadow 0.18s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 6px 24px rgba(71,85,105,0.35)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "";
              e.currentTarget.style.boxShadow = "0 4px 18px rgba(71,85,105,0.25)";
            }}
          >
            Let&apos;s Go <span aria-hidden="true">→</span>
          </button>
        )}
      </div>
    </div>
  );
}
